import React from 'react';
import styled, { keyframes } from 'styled-components';

const LoadingSpinner = ({ size = 28, color = 'var(--color-primary)' }) => (
  <Wrap>
    <Spin $size={size} $color={color} />
  </Wrap>
);

export default LoadingSpinner;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
`;

const Spin = styled.div`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border: 3px solid #E5E7EB;
  border-top-color: ${({ $color }) => $color};
  border-radius: 50%;
  animation: ${spin} 0.6s linear infinite;
`;
